import { classify } from 'sidecar-utilities'

export const legendStyles = classify({
  layout: 'mt-6 mb-1 first:mt-0',
  font: 'font-sans-bold font-bold text-lg md:text-xl lining-nums',
  color: 'color-textOnDefaultStrong',
})

export const containerStyles = classify({
  flex: 'flex items-start',
  layout: 'py-2',
})

export const inputStyles = classify({
  reset: 'appearance-none block cursor-pointer',
  borderRadius: 'rounded-full',
  layout: 'w-5 h-5 mx-0 my-0.5',
  borderWidth: 'border checked:border-6',
  color: 'color-onPrimary',
  regularState: 'color-borderDefaultDecorStrong',
  hoverState: 'hover:color-borderDefaultDecorStrong-hover',
  activeState: 'active:color-borderDefaultDecorStrong-active',
  disabledState:
    'disabled:color-borderBoolean-off-disabled disabled:cursor-not-allowed',
  errorState: 'invalid:color-borderBoolean-off-error',
  selectedState: 'checked:color-borderPrimary',
  selectedHoverState: 'hover:checked:color-borderPrimary',
  selectedActiveState: 'active:checked:color-borderPrimary',
  selectedDisabledState: 'checked:disabled:color-borderPrimary-disabled',
  selectederrorState: 'checked:invalid:color-borderBoolean-on-error',
  focusState:
    'focus:outline focus:outline-offset-0 focus:outline-8 focus:color-outlinePrimaryDecor',
  other: 'peer/radio',
})

export const labelStyles = classify({
  // Use padding-left instead of gap to increase click area
  spaceBetweenInputAndLabel: 'pl-3',
  group: 'group/labelContainer',
  cursor: 'cursor-pointer peer-disabled/radio:cursor-not-allowed',
  //Lighten the color of both the title and subtitle
  disabledTitle: 'peer-disabled/radio:[&_span]:color-textOnDefaultWeak',
})

export const titleStyles = classify({
  font: 'block',
})

export const subtitleStyles = 'block sh-body-sm'
